import { render } from "./BanobagiBannerCarousel.vue?vue&type=template&id=0c74be2b&scoped=true"
import script from "./BanobagiBannerCarousel.vue?vue&type=script&lang=js"
export * from "./BanobagiBannerCarousel.vue?vue&type=script&lang=js"

import "./BanobagiBannerCarousel.vue?vue&type=style&index=0&id=0c74be2b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c74be2b"]])

export default __exports__